export default "__VITE_ASSET__DAiuRaPq__"